import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiMethod } from '../../apimethods/api-method';
import * as ngswal from "sweetalert";
import { Testassessment } from './testassessmentmodel';
import { GlobalConstants } from '../../common/global-constants';
import { FreelancerlistComponent } from '../freelancerlist/freelancerlist.component';
import { ViewChild } from '@angular/core';


declare var $;
@Component({
  selector: 'app-test-assessment',
  templateUrl: './test-assessment.component.html',
  styleUrls: ['./test-assessment.component.css']
})
/** TestAssessment component*/
export class TestAssessmentComponent implements OnInit {

  modelItem = new Testassessment();
  VendorName: any;
  EmailID: any;
  Category: any;
  showpopupTestassign: boolean;
  static VendorName: string;
  static EmailID: string;
  static Category: string;
  static EvaluationID: any;

  ngOnInit(): void {
    ApiMethod.getBaseUrl();
    $('#Txt_Result').select2({
      placeholder: "Select Result",
      allowClear: true, tags: true,
      dropdownParent: "#tblVendor"
    });
    $('#Txt_Result').val([]).trigger('change');
    $('.DetailScroll').css('height', GlobalConstants.size.height - 180)
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <Testassessment>data["TestAssessmentPage"];

      },
      error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  public static AssessmentDetails(ID) {
    this.EvaluationID = ID;
    ApiMethod.getMethod("api/FreelancerTestDetailsByID/" + ID + "/" + localStorage.aPubID).subscribe(
      Response => {
        var aItems = Response.aTestData;

        var _aChecklist = Response.aTaskChecklist;
        $('#text_vendorname').text(aItems[0].VendorName);
        $('#EmailId').text(aItems[0].EmailID);
        $('#category').text(aItems[0].TaskName);
        $('#Articleno').text(aItems[0].ArticleNo);


        $("#tbl_checklist tbody").empty();
        if (_aChecklist.length !== 0) {
          var nRowR = "";
          for (let i = 0; i < _aChecklist.length; i++) {
            console.log(_aChecklist[i].Checklist);
            nRowR += "<tr id='tr" + (i + 1).toString() + "'>";
            nRowR += "<td>" + (i + 1) + "</td>";
            nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(_aChecklist[i].Id) + "</td>";
            nRowR += "<td>" + GlobalConstants.isNullCheck(_aChecklist[i].Checklist) + "</td>";
            nRowR += "<td><div class='emoji-table'><div class='emoji-div'><div class='rating' data-rating-id='" + (i + 1) + "'></div></div></div></td>";
            nRowR += "</tr>";
          }
          $("#tbl_checklist tbody").append(nRowR);


          $(".emoji-table .rating").each(function (ind) {
            $(this).emoji({
              width: '18px',
              //starRating: true,
              //value: 3.5,
              emojis: ['&#x2B50;', '&#x2B50;', '&#x2B50;', '&#x2B50;', '&#x2B50;'],
            });
          });
        }

        $("#LoadingImagePopup2").hide();
      }, error => {
        $("#LoadingImagePopup2").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  //Test Assesment Score
  getpopupTestScoredata() {
    $("#LoadingImagePopup2").show();
    $('#btnPopupassessment').show();
    if (TestAssessmentComponent.EvaluationID != 0) {
      ApiMethod.getMethod(this.modelItem.FreelancerTestAssesment + "/" + TestAssessmentComponent.EvaluationID + "/" + localStorage.aPubID).subscribe(
        Response => {
          var aItems = Response.aTestData;
          var _aChecklist = Response.aTaskChecklist;
          TestAssessmentComponent.VendorName = aItems[0].VendorName;
          TestAssessmentComponent.EmailID = aItems[0].EmailID;
          TestAssessmentComponent.Category = aItems[0].TaskName;
          $("#LoadingImagePopup2").hide();
        }, error => {
          $("#LoadingImagePopup2").hide();
          ngswal("Failed !", error.message, "error");
        });
    }
  }




  HideAssesment() {
    FreelancerlistComponent.Testassessmenthide();
  }

  hide() {
    $('#btnPopupartDetails').hide();
    $('#btnPopuptestDetails').hide();
    $('#btnPopupassessment').hide();
  }

  Testassignhide() {
    this.showpopupTestassign = false;
  }


  AddSummary() {
    var dt = new Date();
    var time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds() + ":" + dt.getMilliseconds();
    var zRowLength = $("#tbl_summarylist tbody").find("tr").length;
    var nRow = "<tr><td style='width:2%;text-align:center' class='rowNo'>" + (zRowLength + 1).toString() + "</td>"
      + "<td><input type='text' class='form-control' placeholder='Enter the Issues' min='0'></td>"
      + "<td><input type='text' class='form-control' placeholder='Enter the Examples' maxlength='100'></td>"
      + "<td style='width:5%'><input type='number' class='form-control' placeholder='Page #' min='0'></td>"
      + "<td style='width:5%;text-align:center;'><i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;text-align:center;' onclick=localStorage.aDeleteID='" + (zRowLength + 1).toString() + time + "';$('#btnDeleteSummary').trigger('click');></i></td>"
      + "<td style='display:none' class='random'>" + (zRowLength + 1).toString() + time + "</td>"
      + "</tr>";
    $("#tbl_summarylist tbody").append(nRow);
  }

  DeleteSummay() {
    $('#tbl_summarylist tr').each(function () {

      if ($(this).find(".random").html().toString().trim() == localStorage.aDeleteID.toString().trim()) {

        $(this).closest("tr").remove();
      }

    });
    let i = 0;
    $('#tbl_summarylist tr').each(function () {
      $(this).find(".rowNo").html(i);
      i = i + 1;

    });
  }
  Updateassessment() {

    if ($('#Txt_Result').val() == "" || $('#Txt_Result').val() == null) {
      ngswal("Warning !", "Enter Result Status!", "warning");
    } else if ($('#Txt_Score').val() == "") {
      ngswal("Warning !", "Enter Score!", "warning");
    }
    else if ($('#Txt_Remarks').val() == "") {
      ngswal("Warning !", "Enter Remarks!", "warning");
    }
    else {
      $("#LoadingImagePopup2").show();

      var checkList = [];
      checkList = GlobalConstants.GetTableRowToList('tbl_checklist', null, false);
      for (var i = 0; i < checkList.length; i++) {
        checkList[i] = checkList[i].toString();
      }
      var summaryList = [];
      summaryList = GlobalConstants.GetTableRowToList('tbl_summarylist', null, false);
      for (var i = 0; i < summaryList.length; i++) {
        summaryList[i] = summaryList[i].toString();
      }

      var dataItem = {
        ID: TestAssessmentComponent.EvaluationID,
        PublisherId: localStorage.aPubID,
        ResultStatus: $('#Txt_Result').val(),
        Rating: $('#Txt_Score').val(),
        ResultRemarks: $('#Txt_Remarks').val(),
        UpdatedBy: localStorage.aLoginID,
        CheckList: checkList,
        SummaryList: summaryList

      };
      ApiMethod.postMethod(this.modelItem.UpdateTestAssesmentAPI, dataItem).subscribe(
        (response) => {
          if (response.Status) {

            FreelancerlistComponent.Testassessmenthide();
            ngswal("Success!", response.Message, "success");
          }
          else {
            ngswal("Failed!", response.Message, "warning");
          }
          $("#LoadingImagePopup2").hide();

        },
        (error) => {
          ngswal("Failed!", error.error.Message, "warning");
          $("#LoadingImagePopup2").hide();
        }
      );
    }
  }
  downloadAssignedTestFile() {
    $("#LoadingImagePopup2").show();
    ApiMethod.Downloadfile(this.modelItem.getFreelancertestfileAPI + TestAssessmentComponent.EvaluationID);
    $("#LoadingImagePopup2").hide();
  }


  downloadUploadedTestFile() {
    $("#LoadingImagePopup2").show();
    ApiMethod.Downloadfile(this.modelItem.getFreelancerUploadedTestFileDownload + "/" + TestAssessmentComponent.EvaluationID);
    $("#LoadingImagePopup2").hide();
  }
}

